export const normalizeGroupByValue = (value) => String(value ?? '').trim().toLowerCase();

export const isWorkspaceGroupedByField = (workspaceName, workspaces = [], field) => {
  const workspace = (Array.isArray(workspaces) ? workspaces : [])
    .find((item) => item?.name === workspaceName);

  return normalizeGroupByValue(workspace?.group_by) === normalizeGroupByValue(field);
};

export const extractCommandIdFromResponse = (response) => (
  response?.command_id ??
  response?.commandId ??
  response?.metadata?.command_id ??
  response?.data?.command_id ??
  null
);

export const extractUpdatedVulnerabilityFromResponse = (response, fallback = null) => {
  if (response?._id || response?.id) return response;

  const nestedVulnerability = (
    response?.vulnerability ??
    response?.vuln ??
    response?.data?.vulnerability ??
    response?.data?.vuln ??
    response?.data
  );

  if (nestedVulnerability?._id || nestedVulnerability?.id) return nestedVulnerability;
  return fallback;
};

const normalizeCveList = (list = []) => (
  Array.isArray(list)
    ? list
      .map((item) => String(item ?? '').trim().toUpperCase())
      .filter(Boolean)
      .sort()
    : []
);

const hasNonEmptyName = (value) => String(value ?? '').trim() !== '';

export const hasCveValues = (list = []) => normalizeCveList(list).length > 0;

export const hasCveListChanged = (initialList = [], currentList = []) => {
  const left = normalizeCveList(initialList);
  const right = normalizeCveList(currentList);

  if (left.length !== right.length) return true;
  return left.some((item, index) => item !== right[index]);
};

export const shouldTreatFieldUpdateAsGrouping = ({
  workspaceName,
  workspaces = [],
  field,
  commandId,
  isGrouping
}) => {
  if (isGrouping === true) return true;
  if (!commandId) return false;
  return isWorkspaceGroupedByField(workspaceName, workspaces, field);
};

export const shouldTreatCreatedVulnAsGrouping = ({
  workspaceName,
  workspaces = [],
  commandId,
  isGrouping,
  name,
  cve
}) => {
  if (isGrouping === true) return true;
  if (!commandId) return false;

  if (isWorkspaceGroupedByField(workspaceName, workspaces, 'name') && hasNonEmptyName(name)) {
    return true;
  }

  if (isWorkspaceGroupedByField(workspaceName, workspaces, 'cve') && hasCveValues(cve)) {
    return true;
  }

  return false;
};
